import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { TIERS } from '../../content/tiers';

/**
 * Which option (Make Your Own, We Mix It For You, Restored & Remastered) a NEW video
 * was started with. It comes from the option cards ("+ New Video", the dashboard,
 * the homepage) as router state, or as ?tier= after signing up or signing in first
 * (router state can't survive that round trip). Returns null when none was chosen.
 */
export const chosenTierId = (location) => {
  const id = location?.state?.tier || new URLSearchParams(location?.search || '').get('tier');
  return TIERS.some((t) => t.id === id) ? id : null;
};

/**
 * Founder rule (28 Sep): families choose how their video is made BEFORE it starts.
 * A new video can only be started with an option chosen; any other way in (an old
 * link, a bookmark, a "Create a memorial video" button) goes to the option chooser
 * first. Existing videos (/projects/:id/edit) keep the option they were started with.
 */
const RequireChosenOption = ({ children }) => {
  const location = useLocation();
  if (!chosenTierId(location)) return <Navigate to="/projects/choose" replace />;
  return children;
};

export default RequireChosenOption;
